import { supabase, isSupabaseConfigured } from '@/lib/supabase';

// Opción de venta para los selectores de los modales de postventa
// (devoluciones, cambios y garantías). Incluye el customer_id para poder
// enlazar la novedad al cliente de la venta original.
export interface SaleOption {
  id: string;
  saleNumber: string;
  customerId: string;
  customerName: string;
}

export async function fetchSalesForSelect(): Promise<SaleOption[]> {
  if (!isSupabaseConfigured || !supabase) return [];

  try {
    const [salesRes, customersRes] = await Promise.all([
      supabase.from('sales').select('id, sale_number, customer_id'),
      supabase.from('customers').select('id, first_name, last_name'),
    ]);

    if (salesRes.error || customersRes.error) {
      console.warn('[lookup] sales query failed');
      return [];
    }

    const customerMap = new Map(
      ((customersRes.data ?? []) as Array<Record<string, any>>).map((c) => [c.id, c]),
    );

    return ((salesRes.data ?? []) as Array<Record<string, any>>).map((s) => {
      const c = customerMap.get(s.customer_id);
      return {
        id: s.id,
        saleNumber: s.sale_number,
        customerId: s.customer_id,
        customerName: c ? `${c.first_name ?? ''} ${c.last_name ?? ''}`.trim() : '',
      };
    });
  } catch (err) {
    console.warn('[lookup] connection failed:', err);
    return [];
  }
}